<template>
  <div class="date-picker-schedule">
    <el-date-picker
      class="picker-input"
      unlink-panels
      type="daterange"
      align="right"
      value-format="timestamp"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      v-model="valueBackUp"
      :picker-options="pickerOptions"
    >
    </el-date-picker>
    <template v-if="storeId">
      <div v-if="isLoading" class="date-picker-tip">正在获取已占用日期…</div>
      <div v-else-if="list.length" class="date-picker-tip">
        <span class="date-picker-tip-label">灰色日期已被其他课表占用，不可选择：</span>
        <span
          v-for="(item, index) in list"
          :key="item.id || index"
          class="date-picker-tip-item"
        >
          {{ item.schedule_name ? `「${item.schedule_name}」` : '其他课表' }} {{ formatDate(item.start_date) }} ~ {{ formatDate(item.end_date) }}{{ index !== list.length - 1 ? '；' : '' }}
        </span>
      </div>
      <div v-else class="date-picker-tip">当前门店暂无其他课表占用日期，可选未来任意日期范围。</div>
    </template>
  </div>
</template>

<script>
import { getDisabledDates } from '@/api/course-schedule';

export default {
  props: {
    value: Array,
    storeId: [Number, String],
    excludeId: [Number, String],
  },
  data() {
    return {
      valueBackUp: '',
      list: [],
      isLoading: false,
      pickerOptions: {
        disabledDate: (canPickTime) => {
          let time = canPickTime.getTime();
          if (time <= Date.now() - 8.64e7) return true;
          time /= 1000;
          return this.list.some((v) => time >= v.start_date && time <= v.end_date);
        },
      },
    };
  },
  watch: {
    value(value) {
      if (value !== this.valueBackUp) this.valueBackUp = value;
    },
    valueBackUp(valueBackUp) {
      if (valueBackUp !== this.value) this.$emit('input', valueBackUp);
    },
    storeId(storeId) {
      this.list = [];
      if (storeId) this.getList(storeId);
    },
  },
  mounted() {
    if (this.storeId) this.getList(this.storeId);
  },
  methods: {
    async getList(store_id) {
      this.isLoading = true;
      this.list = [];
      const { isError, data } = await getDisabledDates(store_id);
      if (!isError) {
        const today = Math.floor(Date.now() / 1000);
        this.list = (data || []).filter((item) =>
          Number(item.id) !== Number(this.excludeId) && Number(item.end_date) >= today
        );
      }
      this.isLoading = false;
    },
    formatDate(time) {
      if (!time) return '';
      const date = new Date(Number(time) * 1000);
      const month = `${date.getMonth() + 1}`.padStart(2, '0');
      const day = `${date.getDate()}`.padStart(2, '0');
      return `${date.getFullYear()}-${month}-${day}`;
    },
    handleChange(valueBackUp) {
      this.$emit('change', valueBackUp);
    },
  },
};
</script>

<style src="./index.css" scoped/>
